/**
 * «عکس‌های مشکوک» در سربرگِ «عکس‌ها» — WHOSUP-300، مایگریشن 0161.
 *
 * عکسی که کاربرها گزارش کرده‌اند «باز نشد» (`client_errors`، image.load)،
 * از آستانه‌ی `lib/suspectImages` گذشته، و حکمِ تستِ سمتِ سرور اگر کرالر
 * انجامش داده باشد. نگاهِ اول فقط سه عدد؛ نمونه‌ها با «بیشتر».
 *
 * ⚠ این کارت چیزی را علامتِ خراب نمی‌زند. `invalid_images` را کرالر بعد از
 * تستِ خودش پر می‌کند.
 */
import React, { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { opsRepo } from '@/core/data/opsRepo';
import { formatDateTime } from '@/core/lib/dates';
import { describeError } from '@/core/lib/report';
import {
  SUSPECT_MIN_SESSIONS, SUSPECT_MIN_USERS, SUSPECT_WINDOW_DAYS, VERDICT_LABEL,
} from '@/core/lib/suspectImages';
import { Hint } from '@/ui/Hint';
import { fmtNum as fmt } from '@/ui/Num';

const SUSPECT_HELP =
  `عکسی که در ${SUSPECT_WINDOW_DAYS} روزِ گذشته دست‌کم ${SUSPECT_MIN_USERS} کاربرِ مختلف یا `
  + `${SUSPECT_MIN_SESSIONS} نشستِ مختلف گزارش کرده‌اند «باز نشد». حساب‌های داخلی شمرده نمی‌شوند.`;

export function SuspectImages() {
  const q = useQuery({ queryKey: ['eventPhotos', 'suspect'], queryFn: () => opsRepo.suspectImages() });
  const [more, setMore] = useState(false);
  const head = <h2><Hint text="عکس‌های مشکوک" help={SUSPECT_HELP} /></h2>;

  if (q.isLoading) return <div className="card">{head}<p className="dim">…</p></div>;
  if (q.error) return <div className="card">{head}<p className="err">{describeError(q.error)}</p></div>;

  const { totals: t, samples } = q.data!;

  return (
    <div className="card">
      {head}
      <div className="grid n3" style={{ marginTop: 10 }}>
        <div className="stat">
          <div className="n">{fmt(t.suspect)}</div>
          <div className="k">
            <Hint text="مشکوک" help={`${fmt(t.untested)} تا هنوز تستِ سرور نخورده‌اند.`} />
          </div>
        </div>
        <div className="stat">
          <div className={`n${t.broken > 0 ? ' err' : ''}`}>{fmt(t.broken)}</div>
          <div className="k"><Hint text="خرابِ قطعی" help="تستِ سرور هم بازش نکرد." /></div>
        </div>
        <div className="stat">
          <div className="n">{fmt(t.hotlink_blocked)}</div>
          <div className="k">
            <Hint text="بسته برای سایت‌های دیگر"
              help="عکس سالم است، ولی منبع نمی‌گذارد سایتِ دیگری نشانش دهد." />
          </div>
        </div>
      </div>

      {samples.length > 0 ? (
        <button type="button" className="linkbtn" style={{ marginTop: 10 }} onClick={() => setMore(!more)}>
          {more ? 'کمتر' : 'بیشتر'}
        </button>
      ) : null}

      {more ? (
        <div className="scrollx" style={{ marginTop: 10 }}>
          <table>
            <thead>
              <tr>
                <th>عکس</th><th>کاربر</th><th>نشست</th><th>گزارش</th>
                <th>آخرین گزارش</th><th>حکم</th><th>تست</th>
              </tr>
            </thead>
            <tbody>
              {samples.map((s) => (
                <tr key={s.url}>
                  <td>
                    <a className="mono ltr" href={s.url} target="_blank" rel="noreferrer" title={s.url}
                      style={{ display: 'inline-block', maxWidth: 320, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                      {s.url}
                    </a>
                  </td>
                  <td className="num">{fmt(s.users)}</td>
                  <td className="num">{fmt(s.sessions)}</td>
                  <td className="num">{fmt(s.reports)}</td>
                  <td className="num">{formatDateTime(s.last_reported_at)}</td>
                  <td>{s.verdict ? VERDICT_LABEL[s.verdict] : <span className="dim">تست نشده</span>}</td>
                  <td className="mono ltr dim">
                    {s.checked_at ? `${s.http_status ?? '—'} · ${s.content_type ?? '—'} · ${formatDateTime(s.checked_at)}` : '—'}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : null}
    </div>
  );
}
